export const defaultPropsInput = {
  computed: {
    defaultProps: function () {
      let defaultProps = {
        solo: false,
        outlined: true,
        dense: true,
        color: this.$vuetify.theme.themes.light.tertiary,
        class: "rounded-lg",
        "hide-details": "auto",
        "validate-on-blur": true,
      };

      switch (this.variant) {
        case "login": {
          defaultProps = {
            ...defaultProps,
            class: "mb-4",
            autocomplete: "on",
          };
          break;
        }
        case "login-select": {
          defaultProps = {
            ...defaultProps,
            class: "mb-4",
          };
          break;
        }
        case "input-file": {
          defaultProps = {
            ...defaultProps,
            class: "input-file-tema",
          };
          break;
        }
      }

      return defaultProps;
    },
  },
};

export default defaultPropsInput;
